module.exports = __webpack_public_path__ + "public/img/logo_horizontal_clustervet.8f3ca65e.svg";